import { render } from "./PlanCoursewareCard.vue?vue&type=template&id=e4d97f40&scoped=true"
import script from "./PlanCoursewareCard.vue?vue&type=script&lang=ts"
export * from "./PlanCoursewareCard.vue?vue&type=script&lang=ts"

import "./PlanCoursewareCard.vue?vue&type=style&index=0&id=e4d97f40&scoped=true&lang=css"
import "./PlanCoursewareCard.vue?vue&type=style&index=1&id=e4d97f40&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-e4d97f40"

export default script